import React from 'react';
import ReactDOM from 'react-dom';

const MainComponent = require('./integrations/' + (process.env.REACT_APP_INTEGRATION || 'common')).default;

const App = MainComponent || require('./App').default;

ReactDOM.render(<App />, document.getElementById('root'));
